import React from "react";

import { Grid, Typography } from "@material-ui/core";

import SelectBox from "../../common/SelectBox/SelectBox";
import LinkButton from "../../common/LinkButton/LinkButton";
import { COUNTRY_SETTING_TEXT_CONSTANT } from "../CountrySettingsUtils";

interface RenderAdvanceSlotDaysInterface {
  classes: any;
  advanceSlotDays: any;
  showAdvanceSlotDaysInput: any;
  menuItems: any;
  name: any;
  value: any;
  handleChange: any;
  handleAdvanceDaysClick: any;
  serviceTypeName: any;
}

const RenderAdvanceSlotDays = (props: RenderAdvanceSlotDaysInterface) => {
  const { classes, advanceSlotDays, showAdvanceSlotDaysInput, menuItems, name, value, handleChange, handleAdvanceDaysClick, serviceTypeName } = props;

  return (
    <Grid item xs={2}>
      <Grid container spacing={0} justifyContent="flex-start">
        <Grid item xs={12} className={classes.advanceSlotDaysContainer}>
          <Typography className={classes.serviceTypeContentTitle}>
            {`${COUNTRY_SETTING_TEXT_CONSTANT.ADVANCE_SLOT_DAYS} : ${advanceSlotDays || "0"}`}
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.advanceSlotDaysInput}>
          {showAdvanceSlotDaysInput ? (
            <Grid container>
              <Grid item xs={12}>
                <SelectBox name={name} menuItems={menuItems} value={value} handleChange={handleChange} />
              </Grid>
            </Grid>
          ) : (
            <LinkButton
              buttonLabel={COUNTRY_SETTING_TEXT_CONSTANT.EDIT_DAYS}
              className={classes.editDaysButton}
              onClick={() => handleAdvanceDaysClick(serviceTypeName)}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default React.memo(RenderAdvanceSlotDays);
